// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1lPG6","head":"Table_head__UZR4q","col":"Table_col__2ZaYg"};